export function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

const toString = Object.prototype.toString;
const OBJECT_STRING = '[object Object]';

export function isPlainObject(obj) {
    return toString.call(obj) === OBJECT_STRING;
}

export function remove(arr, item) {
    if (arr.length) {
        const index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}

export function looseEqual(a, b) {
    if (a === b) {
        return true;
    }
    const isObjectA = isObject(a);
    const isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            const isArrayA = Array.isArray(a);
            const isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (
                    a.length === b.length &&
                    a.every((e, i) => {
                        return looseEqual(e, b[i]);
                    })
                );
            } else if (!isArrayA && !isArrayB) {
                const keysA = Object.keys(a);
                const keysB = Object.keys(b);
                return (
                    keysA.length === keysB.length &&
                    keysA.every((key) => {
                        return looseEqual(a[key], b[key]);
                    })
                );
            } else {
                /* istanbul ignore next */
                return false;
            }
        } catch (e) {
            /* istanbul ignore next */
            return false;
        }
    } else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    } else {
        return false;
    }
}

export function convertToDateIfString(str) {
    if (typeof str === 'string') {
        const date = new Date(str);
        // IE and old versions of Safari don't handle ISO format
        if (!isNaN(date) && !date.toString().includes('Invalid')) {
            return date;
        }

        const dateTimeRe = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})([-+])(\d{2})(\d{2})$/;
        let match = dateTimeRe.exec(str);
        if (match) {
            const utcDate = new Date(Date.UTC(match[1], match[2] - 1, match[3], match[4], match[5], match[6], match[7]));
            const sign = match[8] === '+' ? 1 : -1;
            const offsetInMinutes = match[9] * 60 + match[10];
            const offsetInMs = offsetInMinutes * 60 * 1000;
            utcDate.setTime(utcDate.getTime() + sign * offsetInMs);
            return utcDate;
        }

        const dateRe = /^(\d{4})-(\d{2})-(\d{2})$/;
        match = dateRe.exec(str);
        if (match) {
            return new Date(match[1], match[2] - 1, match[3]);
        }
    }

    return str;
}

export function isValidJSON(message) {
    // See https://stackoverflow.com/a/3710506/1343257
    return /^[\],:{}\s]*$/.test(
        message
            .replace(/\\["\\/bfnrtu]/g, '@')
            .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']')
            .replace(/(?:^|:|,)(?:\s*\[)+/g, ''),
    );
}
